import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui, use_slice_user } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { cn } from '@/utils/utils_client';
import { CALLBACK__void } from '@shared/types/types';
import { FC, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  start_slug: string;
  unlink_func?: CALLBACK__void;
  linked?: boolean;
  disabled?: boolean;
  className?: string;
}

export const ButtonSocialNetwork: FC<Props> = ({ start_slug, unlink_func, linked, className, disabled, children }) => {
  const dispatch = use_dispatch();

  const { page_auth_is_loading } = use_slice_ui(['page_auth_is_loading']);
  const { auth_token } = use_slice_user(['auth_token']);

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (linked) {
      unlink_func?.();
    } else {
      dispatch(LOCAL__ui_set_boolean({ value: true, key: 'page_auth_is_loading' }));

      window.location.href = `${CONSTANTS__environment_client.VITE_SERVICE_ULTIMATEDIFFUSION_HTTP_URL_BASE}${start_slug}?user_auth_token=${auth_token}`;
    }
  };

  return (
    <UI_PRIMITIVE__button
      variant="outline-on-component"
      onClick={onClick}
      disabled={page_auth_is_loading || disabled}
      className="w-56 justify-start text-bar-foreground"
    >
      <div className={cn('flex items-center justify-start gap-1.5', linked && !disabled && '[&>span]:text-danger', className)}>{children}</div>
    </UI_PRIMITIVE__button>
  );
};
